import React, { FC } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

type ConfirmationDialogProps = {
  show: boolean;
  bodyMessage: string;
  onHide: () => void;
  onConfirm: () => void;
};

const ConfirmationDialog: FC<ConfirmationDialogProps> = ({
  show,
  bodyMessage,
  onHide,
  onConfirm: onCompleteStichingConfirm
}) => {
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Confirm</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p>{bodyMessage}</p>
      </Modal.Body>

      <Modal.Footer>
        <Button onClick={onCompleteStichingConfirm} variant="secondary">
          OK
        </Button>
        <Button onClick={onHide} variant="primary">
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationDialog;
